<!--上市公司-->
<template>
  <div class="listed-container">
    <div class="listed-content">
      <div class="listed-search-menu">
        <span>搜索到<span style="color: #fe273b">{{ tablePage.total > 5000 ? '5000+' : tablePage.total }}</span>个结果</span>
        <div class="listed-search-right">
          <el-cascader v-model="region" placeholder="全国" :options="regionItem" @change="changeRegion"
                       :show-all-levels="false" style="width: 120px;margin-right: 10px" clearable></el-cascader>
          <el-select v-model="exchange" placeholder="交易所" style="width: 120px;margin-right: 10px" clearable>
            <el-option v-for="item in exchangeItem" :label="item" :value="item"/>
          </el-select>
          <el-date-picker v-model="year" value-format="yyyy" type="year" class="listed-date" placeholder="上市日期"
                          style="width: 140px;margin-right: 10px"/>
          <el-input placeholder="请输入股票简称、股票代码、企业名称等" v-model="keyword" class="keyword-input" style="width: 345px"
                    @keyup.enter.native="getListedCompany">
            <el-button type="danger" slot="append" @click="getListedCompany">搜索</el-button>
          </el-input>
        </div>
      </div>
      <div class="listed-table">
        <vxe-table :height="Theight" stripe border align="center" :data="listedCompanyInfo"
                   :column-config="{resizable: true}" @cell-click="enterpriseDetails"
                   :header-cell-style="{backgroundColor: '#F4F5FD',color: '#333333'}">
          <vxe-column field="name" title="股票名称">
            <template #default="{ row }">
              <el-link type="primary" :underline="false">{{ row.name }}</el-link>
            </template>
          </vxe-column>
          <vxe-column field="code" title="股票代码" width="150"/>
          <vxe-column field="company" title="公司名称" show-overflow>
            <template #default="{ row }">
              <el-link type="primary" :underline="false">{{ row.company }}</el-link>
            </template>
          </vxe-column>
          <vxe-column field="stockName" title="交易所名称" width="180"/>
          <vxe-column field="time" title="上市日期" width="120"/>
        </vxe-table>
        <div style="padding:10px 10px 0px;">
          <page :total="tablePage.total" @currentPage="currentPage" :limit="tablePage.pageSize" style="float: right;"/>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue';
import VXETable from 'vxe-table';
import 'vxe-table/lib/index.css';
import page from "@/components/page/pages";

Vue.use(VXETable)
import {exchangeList, listedCompanyList} from '@/api/enterprise_searchApi'
import cityJson from "@/static/cityJson.json";
import cityJsonList from '@/static/city2.json';

export default {
  name: "listedCompany",
  components: {page},
  data() {
    return {
      region: [],
      exchange: '',
      exchangeItem: [],
      regionItem: cityJsonList,
      listedCompanyInfo: [],
      cityList: {},
      queryAllCityType:0,
      year: '',
      keyword: '',
      tablePage: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      Theight: document.documentElement.clientHeight - 477
    }
  },
  watch: {
    year(newVal, oldVal) {
      if (newVal != oldVal) {
        this.getListedCompany();
      }
    },
    region(newVal, oldVal) {
      if (newVal != oldVal) {
        this.getListedCompany();
      }
    },
    exchange(newVal, oldVal) {
      if (newVal != oldVal) {
        this.getListedCompany();
      }
    },
  },
  methods: {
    /*获取上市企业*/
    getListedCompany() {
      listedCompanyList({
        cityCode: this.region[1],
        keyword: this.keyword,
        page: this.tablePage.currentPage,
        pageLimit: this.tablePage.pageSize,
        queryAllCityType: this.queryAllCityType,
        stockName: this.exchange,
        type: 1,
        year: this.year || 0,
        yearName: ""
      }).then(res => {
        if (res.code == 200) {
          this.tablePage.total = parseInt(res.content.total);
          this.listedCompanyInfo = res.content.rows;
          console.log(res);
        }
      })
    },
    //切换分页
    currentPage(page) {
      this.tablePage.currentPage = page;
      this.getListedCompany();
    },
    getExchangeItem() {
      exchangeList().then(res => {
        if (res.code == 200) {
          this.exchangeItem = res.content;
          console.log(res);
        }
      })
    },
    /*监听地区修改*/
    changeRegion(value){
      if (value[0]==value[1]){
        this.queryAllCityType=0;
      }else if (value[1]==110100 || value[1]==120100 || value[1]==500100 || value[1]==310100){
        this.queryAllCityType=0;
      }else {
        this.queryAllCityType=1;
      }
    },
    /*查看企业详情*/
    enterpriseDetails(event){
      console.log(event.row)
      let routeData = this.$router.resolve({
        name: "enterpriseDetails",
        path: '/enterpriseDetails/index',
        query: {id:event.row.cid}
      });
      window.open(routeData.href, '_blank')
    }
  },
  mounted() {
    this.getExchangeItem();
    this.getListedCompany();
  },
  beforeMount() {
    if (sessionStorage.getItem('setPositioning')) {
      this.cityList = JSON.parse(sessionStorage.getItem('setPositioning'));
      this.region=[this.cityList.id,this.cityList.vid];
    } else {
      let cityList = JSON.parse(sessionStorage.getItem('locationInfo'));
      for (let li of cityJson) {
        if (cityList.short_name == li.short_name) {
          this.cityList = li;
          this.region=[li.id,li.vid];
        }
      }
    }
  }
}
</script>
<style scoped>
.listed-container >>> .listed-content .listed-search-menu .el-input__inner {
  background-color: #ffffff;
  border-radius: 6px;
  border: 1px solid #DDDDDD;
  color: #333333;
  font-size: 14px;
  height: 40px;
  line-height: 40px;
  padding: 0 10px;
}

.listed-container >>> .listed-content .listed-search-menu input::-webkit-input-placeholder {
  color: #999999;

}

.listed-container >>> .listed-content .listed-search-menu .el-input__suffix {
  display: flex;
  align-items: center;
  right: 10px;
}

.listed-container >>> .listed-content .listed-search-menu .el-icon-search {
  font-size: 19px;
}

.listed-container >>> .listed-content .listed-search-menu .el-input-group__append,
.listed-container >>> .listed-content .listed-search-menu .el-input-group__prepend {
  background-color: #FE273B;
  color: #fff;
  border: 1px solid #FE273B;
  border-radius: 0px 6px 6px 0px;
  padding: 0 20px;
}

.listed-container >>> .listed-content .listed-search-menu .listed-date .el-input__inner {
  background-color: #ffffff;
  border-radius: 6px;
  border: 1px solid #DDDDDD;
  color: #333333;
  font-size: 14px;
  height: 40px;
  line-height: 40px;
  padding: 0 40px;
}

.listed-container >>> .listed-content .listed-search-menu .keyword-input .el-input__inner {
  background-color: #ffffff;
  border: 1px solid #DDDDDD;
  color: #333333;
  font-size: 14px;
  height: 40px;
  line-height: 40px;
  padding: 0 10px;
  border-radius: 6px 0px 0px 6px;
  border-right: none;
}

.listed-container >>> .listed-content .el-link.el-link--primary {
  color: #1637FF;
}
</style>
<style scoped lang="scss">
.listed-container {
  .listed-content {
    .listed-search-menu {
      padding: 20px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid #EBEDF6;
    }

    .listed-table {
      padding: 20px;
    }
  }
}
</style>